module.exports = __webpack_public_path__ + "static/media/uk-icon.3aaf67dd.svg";